export default __webpack_public_path__ + "static/nlp-1-db797aa54f14ee5b856513ee1fff850b.png";